import { selectRequestByType } from 'ducks/requests/selectors'
import { BOOTSTRAP_APP_DATA } from '../types'

export const selectFetchAppBootstrapRequest = state => {
  return selectRequestByType(state, BOOTSTRAP_APP_DATA)
}
